import API_CLIENT from "../../utils/Api";

export async function GetProfile() {
    return await API_CLIENT.get("/authentication/profile");
}